import React from "react"
import axios from "axios";
import DesempenhoTransporteDados from "./DesempenhoTransporteDados";
import DesempenhoTransporteChart from "./DesempenhoTransporteChart";

const CancelToken = axios.CancelToken;
var cancel;

export function fetchData(company, year, month, token) {
    cancel && cancel()

    return axios.get('/api/v2/performance/transporte/' + company + '/' + year + '/' + month,
        {
            headers: {
                "Authorization": token
            },
            cancelToken: new CancelToken(
                function executor(c) {
                    cancel = c;
                }
            )
        })
        .then(response => {
            return response;
        })
        .catch(error => {
            return Promise.reject(error);
        });
}

class DesempenhoTransporteContainer extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isLoading: false,
            data: null
        };

    };

    requestData = () => {

        this.setState({
            isLoading: true,
            data: null
        });

        fetchData(this.props.company, this.props.year, this.props.month, this.props.token)
            .then(response => {
                this.setState({
                    isLoading: false,
                    data: response.data
                });
            })
            .catch(error => {
                if (axios.isCancel(error)) {
                    console.log('Request canceled', error.message);
                } else {
                    console.log(error);
                    this.setState({isLoading: false});
                }
            });
        }

    componentDidMount() {
        this.requestData();
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.month !== prevProps.month) {
            this.requestData();
        }
    }

    render() {

        return (
            <div className="col s12">

                <div className="row">
                    <div className="col s12">
                    <h2 className="page-title-custom page-title-custom">Sensores de transporte</h2>
                    </div>
                </div>

                <div className="row">

                    <DesempenhoTransporteDados isLoading={this.state.isLoading} data={this.state.data} />

                    <DesempenhoTransporteChart isLoading={this.state.isLoading} data={this.state.data} />

                </div>

            </div>
        );
    }
}

export default DesempenhoTransporteContainer
